
// => Styling
import styles from './ShopView.module.css';

// => Icons
import {
    IoReturnDownBack,
} from "react-icons/io5";

// => Sub views
import SubBrowse from './subs/SubBrowse';
import SubCollection from './subs/SubCollection';

// => Components
import SegmentedControl from '../../components/SegmentedControl';
import Modal from '../../components/Modal';
import CardInspect from './components/CardInspect';
import BoosterPackOpening from './components/BoosterPackOpening';

// => React
import { useState } from 'react';


// ============
// Component
// ============
const ShopView = ({
    requestClose,
    currency = 0,
    requestSubtractCurrency = (price) => {},
    unlockedCards,
    requestUnlockCards = (cs) => {},
}) => {

    const subviewItems = [
        {id: "shop", label: "Browse Shop", view: <SubBrowse /*showDevItems*/ unlockedCards={unlockedCards} currency={currency} requestSubtractCurrency={requestSubtractCurrency} requestUnlockCards={requestUnlockCards} requestOpenBoosterPack={(bp, count)=>setOpenBoosterPack({id: bp, cardsAmount: count})}/>},
        {id: "collection", label: "My Collection", view: <SubCollection unlockedCards={unlockedCards} onInspectCard={(d, i, s)=>setInspectCard({data: d, index: i, set: s})} />},
    ]
    const [subview, setSubview] = useState(subviewItems[0].id)

    const [inspectCard, setInspectCard] = useState(null)
    const [openBoosterPack, setOpenBoosterPack] = useState(null)


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            {/* Close FAB //TODO: Make this its own component! */}
            <button className={styles.closeButton} onClick={requestClose}><IoReturnDownBack size="36px"/></button>

            <div className={styles.inner}>

                {/* Subview selection */}
                <SegmentedControl items={subviewItems} activeItem={subview} onSelect={(v)=>setSubview(v)} />

                {/* Subview content */}
                <div className={styles.content}>
                    {subviewItems.find(el => el.id === subview).view}
                </div>

            </div>

            {/* Card inspection modal */}
            {inspectCard && <Modal allowBackgroundClick={true} onBackgroundClick={()=>setInspectCard(null)}>
                <div style={{marginTop: '60px'}}>
                    <CardInspect data={inspectCard.data} index={inspectCard.index} set={inspectCard.set} />
                </div>
                {/* Close FAB // TODO: Make this its own component! */}
                <button className={styles.closeButton} onClick={()=>setInspectCard(null)}><IoReturnDownBack size="36px"/></button>
            </Modal>}

            {/* Open booster pack modal */}
            {openBoosterPack && <Modal allowBackgroundClick onBackgroundClick={()=>setOpenBoosterPack(null)}>
                <BoosterPackOpening boosterPackId={openBoosterPack.id}
                                    cardsAmount={openBoosterPack.cardsAmount}
                                    unlockedCards={unlockedCards}
                                    requestUnlockCards={requestUnlockCards}
                                    onAbort={()=>setOpenBoosterPack(null)} />
                <button className={styles.closeButton} onClick={()=>setOpenBoosterPack(null)}><IoReturnDownBack size="36px"/></button>
            </Modal>}

        </div>
    );
}


export default ShopView